import { useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export const wdEdgeConsolidatedSessionKeys = {
    redirectUrl: "source-redirect-url",
    isSourceWdEdgeConsolidated: "is-source-wdedge-consolidated",
};

const parseEncodedAlerts = (encoded: string | null): any => {
    if (!encoded) return [];
    try {
        const parsed = JSON.parse(atob(encoded));
        return parsed;
    } catch {
        return [];
    }
};

const useWdEdgeConsolidatedSource = () => {
    const [searchParams] = useSearchParams();

    const isSourceConsolidatedParam = searchParams.get("source") === "wdedgeconsolidated";
    const redirectUrlParam = searchParams.get("source-redirect-url");

    if (isSourceConsolidatedParam && redirectUrlParam) {
        sessionStorage.setItem(wdEdgeConsolidatedSessionKeys.redirectUrl, redirectUrlParam);
        sessionStorage.setItem(wdEdgeConsolidatedSessionKeys.isSourceWdEdgeConsolidated, "1");
    }



    const isSourceConsolidated =
        sessionStorage.getItem(wdEdgeConsolidatedSessionKeys.isSourceWdEdgeConsolidated) === "1";

    const redirectUrl =
        sessionStorage.getItem(wdEdgeConsolidatedSessionKeys.redirectUrl) ||
        "";

    return {
        isSourceWdEdgeConsolidated: isSourceConsolidated,
        sourceRedirectUrl: redirectUrl,
    };
};

export default useWdEdgeConsolidatedSource;